import {buildGeneralBooleanSlice} from './general';
import {
    MODAL_RUSH_REFRESH,
    MODAL_AI_SETTINGS,
    MODAL_SUGGESTED_EDITS_PREVIEW,
    MODAL_PROBLEM_FLAGS,
    MODAL_PROBLEM_STARS,
    MODAL_GLOBAL_BOARD_SETTINGS,
    MODAL_PROBLEM_FLAGS_OWNER,
    MODAL_CHANGE_HISTORY,
    MODAL_CHANGE_LEVEL,
} from '../utils/const/modal';

export const modalBoardSettings = buildGeneralBooleanSlice(
    MODAL_GLOBAL_BOARD_SETTINGS
);
export const modalGlobalBoardSettings = modalBoardSettings;
export const modalAiSettings = buildGeneralBooleanSlice(MODAL_AI_SETTINGS);
export const modalRushRefresh = buildGeneralBooleanSlice(MODAL_RUSH_REFRESH);
export const modalSuggestedEditsPreview = buildGeneralBooleanSlice(
    MODAL_SUGGESTED_EDITS_PREVIEW
);
export const modalProblemFlags = buildGeneralBooleanSlice(MODAL_PROBLEM_FLAGS);
export const modalProblemStars = buildGeneralBooleanSlice(MODAL_PROBLEM_STARS);
export const modalProblemFlagsOwner = buildGeneralBooleanSlice(
    MODAL_PROBLEM_FLAGS_OWNER
);
export const modalChangeHistory =
    buildGeneralBooleanSlice(MODAL_CHANGE_HISTORY);
export const modalChangeLevel = buildGeneralBooleanSlice(MODAL_CHANGE_LEVEL);

export const modals = {
    [MODAL_GLOBAL_BOARD_SETTINGS]: modalBoardSettings.reducer,
    [MODAL_AI_SETTINGS]: modalAiSettings.reducer,
    [MODAL_RUSH_REFRESH]: modalRushRefresh.reducer,
    [MODAL_SUGGESTED_EDITS_PREVIEW]: modalSuggestedEditsPreview.reducer,
    [MODAL_PROBLEM_FLAGS]: modalProblemFlags.reducer,
    [MODAL_PROBLEM_STARS]: modalProblemStars.reducer,
    [MODAL_PROBLEM_FLAGS_OWNER]: modalProblemFlagsOwner.reducer,
    [MODAL_CHANGE_HISTORY]: modalChangeHistory.reducer,
    [MODAL_CHANGE_LEVEL]: modalChangeLevel.reducer,
};
